import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IfMachComponent } from './if-mach/if-mach.component';
import { IfPp0Component } from './if-pp0/if-pp0.component';
import { IfTt0Component } from './if-tt0/if-tt0.component';
import { IfAatComponent } from './if-aat/if-aat.component';
import { IfSectionComponent } from './if-section/if-section.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IfPAp0Component } from './if-p-ap0/if-p-ap0.component';


@NgModule({
  declarations: [
    IfMachComponent,
    IfPp0Component,
    IfTt0Component,
    IfAatComponent,
    IfSectionComponent,
    IfPAp0Component

  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule
  ],
  exports: [
    IfSectionComponent,
    IfPp0Component,
    IfMachComponent,
    IfTt0Component,
    IfAatComponent,
    IfPAp0Component
  ]
})
export class RpeIsentMdlModule { }
